import * as React from 'react';
import { render, unmountComponentAtNode } from 'react-dom';

type NodeReference = {
  node: HTMLElement
}

const tooltipReferences: Record<string, NodeReference> = {};

export function renderReactTooltipToElement(baseID: string, element: React.ReactElement, parentTag: string = 'div'): HTMLElement {
  const activeRef = tooltipReferences[baseID];

  if (activeRef?.node) {
    unmountComponentAtNode(activeRef?.node);
  }

  const elementToRender = document.createElement(parentTag);

  tooltipReferences[baseID] = {
    node: elementToRender
  };

  render(element, elementToRender);

  return elementToRender;
}
